import { endDay } from '@/apps/slideshowGame/useCalculation';

export const slide32 = {
  entry: ({ context }) => {
    endDay(context.metadata);
  },
  on: {
    CLICK_NEXT: 'slide33',
  },
  meta: {
    id: 'slide32',
    section: '65f024256da2c5fe406d55a9',
    event: 'CLICK_NEXT',
    display: {
      backgroundColor: '',
      backgroundGradient: '',
      backgroundImage: '',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-no-repeat',
      backgroundOpacity: 1,
      backgroundVideo: '',
      transition: 'slide',
      transitionSpeed: 'default',
      backgroundTransition: 'fade',
    },
    content: [
      {
        name: 'end_day_amount',
        type: 'content',
        content: {
          src: 'https://res.cloudinary.com/dcodkxpej/image/upload/v1722183665/Decision%20making%20game/boy/bzfhozkpdia3rflvzbwh.svg',
          textColor: 'text-white',
          fontFamily: 'simplerRegular',
          prefix: 'הצלחנו להגיע היום לרווח של ',
          suffix: 'שקלים.',
        },
      },
    ],
  },
};
export default slide32;
